/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function($) {
  jQuery(window).load(function() {

    var subscriptionsEnableSelectors = $('.product__form__outer').data('subscriptions-enable-selectors');

  if (!subscriptionsEnableSelectors) {
    $('.grid__item_description').on('click', function() {
      if($("#rc-radio1").is(':checked')) {
        $(".product__form__outer").removeClass("ocultar-important");
        $(".subcripcion_recharge_link").addClass("ocultar-important");
      }

      if($("#rc-radio2").is(':checked')) {
        $(".product__form__outer").addClass("ocultar-important");
        $(".subcripcion_recharge_link").removeClass("ocultar-important");
      }
    });

    $('.product__recharge').on('click', function() {
      if($("#rc-radio1").is(':checked')) {
        $(".product__form__outer").removeClass("ocultar-important");
        $(".subcripcion_recharge_link").addClass("ocultar-important");
      }

      if($("#rc-radio2").is(':checked')) {
        $(".product__form__outer").addClass("ocultar-important");
        $(".subcripcion_recharge_link").removeClass("ocultar-important");
      }
    });
  }

  $('.grid__item_description').on('click', function() {
    if($("#rc-radio1").is(':checked')) {
      $(".subscription-mensaje").removeClass("rc-radio--active");
      $(".onetime-mensaje").addClass("rc-radio--active");
    }

    if($("#rc-radio2").is(':checked')) {
      $(".onetime-mensaje").removeClass("rc-radio--active");
      $(".subscription-mensaje").addClass("rc-radio--active");
    }
  });

  $('.product__recharge').on('click', function() {
    if($("#rc-radio1").is(':checked')) {
      $(".subscrition-div").removeClass("rc-radio--active");
      $(".one-time-div").addClass("rc-radio--active");
    }

    if($("#rc-radio2").is(':checked')) {
      $(".one-time-div").removeClass("rc-radio--active");
      $(".subscrition-div").addClass("rc-radio--active");
    }
  });

    setTimeout(function() {
      $(".grid__item_description .onetime-radio").after( "<div class='onetime-mensaje' style='padding-left: 52px;'>" + $("#lavado_normal").text() + "</div>" );
      $(".grid__item_description .subscription-radio").after( "<div class='subscription-mensaje rc-radio--active' style='padding-left: 52px;'>" + $("#lavado_subcripcion").text() + "</div>" );
    }, 500);
  });
})(jQuery);


//abrir carrito
window.onload = function() {
  var addToCartButton = document.querySelector('.btn--add-to-cart');

  if (addToCartButton) {
    console.log(1);
    addToCartButton.addEventListener('click', function() {
      // Espera un breve momento para permitir que el popup se muestre
      setTimeout(checkPopupAndOpenCart, 1000);
    });
  }
};

function checkPopupAndOpenCart() {
  var popup = document.querySelector('.product-add-popdown.is-visible');
  if (popup) {
    openCartDrawer();
  } else {
    // Si no se muestra el popup, intenta abrir directamente el drawer del carrito
    openCartDrawerDirectly();
  }
}

function openCartDrawer() {
  // Simula un clic en el enlace del carrito para abrir el drawer
  var cartLink = document.querySelector('#carrito-nav');
  if (cartLink) {
    cartLink.click();
  }
}

function openCartDrawerDirectly() {
  // Abre el drawer del carrito directamente si el popup no está presente
  var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
  if (cartDrawer) {
    cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
      bubbles: false
    }));
  }
}

function textTruncate(originalText, maxLength) {
  return {
    originalText: originalText,
    truncatedText: '',
    isExpanded: false, // Controla si el texto está expandido o colapsado
    maxLength: maxLength, // Número de caracteres antes de truncar

    toggleText() {
      this.isExpanded = !this.isExpanded;
      this.truncatedText = this.isExpanded ? this.originalText : this.getTruncatedText();
    },

    getTruncatedText() {
      if (this.originalText.length > this.maxLength) {
        return this.originalText.substring(0, this.maxLength) + '...';
      }
      return this.originalText;
    },

    init() {
      this.truncatedText = this.getTruncatedText();
    }
  }
}

document.addEventListener("DOMContentLoaded", function() {
function updateTooltipPosition(tooltip) {
  const tooltipText = tooltip.querySelector(".lb-tooltip-text");

  // Hacer visible temporalmente el tooltip para medir su tamaño
  tooltipText.style.visibility = "hidden";
  tooltipText.style.display = "block";

  const rect = tooltip.getBoundingClientRect();
  const tooltipHeight = tooltipText.offsetHeight;
  const spaceBelow = window.innerHeight - rect.bottom;
  const spaceAbove = rect.top;

  // Restaurar la visibilidad original
  tooltipText.style.visibility = "";
  tooltipText.style.display = "";

  if (spaceBelow >= tooltipHeight) {
    tooltip.setAttribute("data-tooltip-position", "bottom");
  } else {
    tooltip.setAttribute("data-tooltip-position", "top");
  }
}

// Aplicar la lógica a todos los tooltips
function adjustAllTooltips() {
  document.querySelectorAll("[data-lb-tooltip]").forEach(updateTooltipPosition);
}

// Ajustar al cargar, redimensionar y hacer scroll
adjustAllTooltips();
  window.addEventListener("resize", adjustAllTooltips);
  window.addEventListener("scroll", adjustAllTooltips);
});


// Traducir tags
document.addEventListener("DOMContentLoaded", function () {
  if (Shopify.locale === "fr") {
    const tagTranslations = {
      "consejos": "Conseils",
      "Cuidado de ropa": "Entretien des vêtements",
      "guia": "Guide",
      "medioambiente": "Environnement",
      "moda": "Mode",
      "plásticos": "Plastiques",
      "salud": "Santé",
      "sobre washaby": "À propos de Washaby"
    };

    const tagLinks = document.querySelectorAll(".blog__tag");

    tagLinks.forEach(link => {
      const originalText = link.textContent.trim();
      const translatedText = tagTranslations[originalText];
      if (translatedText) {
        link.textContent = translatedText;
      }
    });
  }
});